import { Navigate, useParams } from "react-router";
import { HELP_GLOSSARY, HELP_START, helpPlaceHref, type HelpPlace } from "./helpArticles";

const OLD_GUIDE_PAGES: Readonly<Record<string, HelpPlace>> = {
  "glossary.html": HELP_GLOSSARY,
  "import.html": { page: "import", section: null },
};

/** An address of the static guide that the help center replaced, such as a bookmark: its page in the help, or the start. */
export default function LegacyGuideRedirect() {
  const { "*": oldPage = "" } = useParams();
  return <Navigate to={helpPlaceHref(OLD_GUIDE_PAGES[oldPage] ?? HELP_START)} replace={true} />;
}
